import { SvgIcon, SvgIconProps } from '@material-ui/core';

const P44Icon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 33 32">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M4.719 27.296h-0.003c-6.115-6.313-6.036-16.364 0.177-22.58s16.262-6.297 22.575-0.183c6.284 6.286 6.284 16.477 0 22.763-0.041 0.047-0.092 0.094-0.142 0.142-6.309 6.138-16.376 6.074-22.608-0.142zM10.664 13.147v4.431h-4.143l4.278-11.356h-2.88l-4.184 11.319v2.77h6.928v4.577h2.815v-4.577h1.812v-2.734h-1.812v-4.431h-2.815zM23.106 13.147v4.431h-4.143l4.282-11.356h-2.88l-4.183 11.319v2.77h6.925v4.577h2.817v-4.577h1.814v-2.734h-1.814v-4.431h-2.817z"></path>
      </g>
    </SvgIcon>
  );
};

export default P44Icon;
